<script setup>
import { default as CheckboxEl } from '@/components/shared/Checkbox.vue';

defineProps({
  image: {
    type: String,
    reqiured: true,
  },
  title: {
    type: String,
    required: true,
  },
  checked: {
    type: Boolean,
    default: false,
  },
  isExternal: {
    type: Boolean,
    default: false,
  },
});
</script>
<template>
  <div
    class="w-full flex items-center justify-between border border-2 border-neutral-300 rounded-xl mb-3 py-3 px-5"
    :class="{ 'border-darkOcean-600 bg-darkOcean-100': checked }"
  >
    <div class="relative">
      <img
        :src="image"
        class="w-[58] h-[58] mr-4 rounded-full border border-2 border-white shadow-small"
      />

      <div
        v-if="isExternal"
        class="absolute shadow-small flex items-center justify-center rounded-full border-white border-2 bg-yellow-300 w-[22px] h-[22px] bottom-[-4px] right-[12px]"
      >
        <fa-icon :icon="['fas', 'hotel']" class="text-black" />
      </div>
    </div>

    <p class="h700 truncate max-w-[326px]">{{ title }}</p>

    <CheckboxEl :checked="checked" />
  </div>
</template>

<style scoped lang="scss">
.svg-inline--fa.fa-hotel {
  height: 10px;
}
</style>
